import { TrackItTaskWorkItemDto } from '@/api/generator';
import { computed, MaybeRefOrGetter, toRef } from 'vue';
import { useJobOccurrence } from './useJobOccurrence';
import { useSupportSystemGroups } from '@/views/jobConfigurations/utils/useSupportSystemGroups';

export function useTrackItTask(workitem: MaybeRefOrGetter<TrackItTaskWorkItemDto>) {
  const workitemRef = toRef(workitem);

  const { supportSystems: allSupportSystems } = useJobOccurrence();

  const { supportSystems, supportSystemGroups, numGroups } = useSupportSystemGroups(
    computed(() => workitemRef.value.supportSystemIds ?? undefined),
    computed(() => allSupportSystems.value ?? undefined),
  );

  return {
    supportSystems,
    supportSystemGroups,
    numGroups,
  };
}
